/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useMemo, useState } from 'react';
import { Paper } from '@mui/material';
import { hasModuleAccess, useAuth } from '@panna/auth';
import { Module } from 'src/access';
import { parseDateString, parseOptionalDate } from 'src/components/RangeDatePicker/utils';
import { InterviewSlotsViewRendererProps, SlotsByDate } from '../../types';
import CreateSlots from '../../components/CreateSlots';
import SlotsFilter from '../../components/SlotsFilter';

function Desktop(props: InterviewSlotsViewRendererProps) {
  const {
    isCalendarLoading,
    highlightedDays,
    monthSlots,
    allSlots,
    getSlotsByMonth,
    saveInterviewSlots,
    deleteInterviewSlot,
    showReschedulePopup,
  } = props;

  const [openSlotsEnabled, setOpenSlotsEnabled] = useState(true);

  const authContext = useAuth();
  const { authState: auth } = authContext;

  const isATSRecruiter = hasModuleAccess(
    auth?.userInfo?.modules || [],
    Module.ATS_RECRUITER || Module.ATS_RECRUITER_ADMIN,
  );

  const isATSInterviewer = hasModuleAccess(
    auth?.userInfo?.modules || [],
    Module.ATS_INTERVIEWER,
  );

  const sortedOpenSlots = useMemo(() => {
    if (!allSlots.OPEN) {
      return {};
    }

    const dates = Object.keys(allSlots.OPEN).sort(
      (a, b) => parseOptionalDate(parseDateString(a), new Date()).getTime()
        - parseOptionalDate(parseDateString(b), new Date()).getTime(),
    );

    const sortedSlots: SlotsByDate = {};
    dates.forEach((date) => {
      sortedSlots[date] = allSlots.OPEN[date];
    });

    return sortedSlots;
  }, [allSlots.OPEN]);

  const sortedReservedSlots = useMemo(() => {
    if (!allSlots.RESERVED) {
      return {};
    }

    const dates = Object.keys(allSlots.RESERVED).sort(
      (a, b) => parseOptionalDate(parseDateString(a), new Date()).getTime()
      - parseOptionalDate(parseDateString(b), new Date()).getTime(),
    );
    const sortedSlots: SlotsByDate = {};
    dates.forEach((date) => {
      sortedSlots[date] = allSlots.RESERVED[date];
    });
    return sortedSlots;
  }, [allSlots.RESERVED]);

  return (
    <div className="flex justify-between">
      <CreateSlots
        isCalendarLoading={isCalendarLoading}
        highlightedDays={highlightedDays}
        isATSRecruiter={isATSRecruiter}
        isATSInterviewer={isATSInterviewer}
        monthSlots={monthSlots}
        getSlotsByMonth={getSlotsByMonth}
        saveInterviewSlots={saveInterviewSlots}
        deleteInterviewSlot={deleteInterviewSlot}
      />
      <Paper className="w-[350px] rounded-t-2xl bg-lightGray">
        <div className="flex w-full shadow-md rounded-2xl">
          <button
            type="button"
            className={`w-1/2 min-h-[40px] rounded-s-2xl border-none font-bold cursor-pointer ${openSlotsEnabled ? 'bg-[#4D586A] text-white' : 'bg-white text-[#4D586A]'}`}
            onClick={() => setOpenSlotsEnabled(true)}
          >
            Open Slots
          </button>
          <button
            type="button"
            className={`w-1/2 min-h-[40px] rounded-e-2xl border-none font-bold cursor-pointer ${openSlotsEnabled ? 'bg-white text-[#4D586A]' : 'bg-[#4D586A] text-white'}`}
            onClick={() => setOpenSlotsEnabled(false)}
          >
            Reserved Slots
          </button>
        </div>
        <SlotsFilter
          slots={openSlotsEnabled ? sortedOpenSlots : sortedReservedSlots}
          openSlotsEnabled={openSlotsEnabled}
          showReschedulePopup={showReschedulePopup}
          deleteInterviewSlot={deleteInterviewSlot}
        />
      </Paper>
    </div>
  );
}

export default Desktop;
